<template>
    <div class="bin-card-monitoring-container">
      <div class="row">
        <div class="col-lg-12 stretch-card">
          <div class="card">
  
            <!-- Body -->
            <div class="card-body">
              <!-- <h4 class="card-title">BIN Card Reports</h4> -->
              <h4 class="card-title">Sales Orders For Resolution Report</h4>
              <div class="filters">
                <div class="row mb-3">
                  <!-- Left Side -->
                  <div class="col-lg-3 col-md-3 col-12 text-left d-flex flex-column">
                    <button type="button" class="btn btn-primary btn-sm-block mt-1 ml-xl-2 ml-lg-2 ml-md-2 ml-sm-2 text-start"
                      @click="uploadModalShow = true">
                      <i class="fas fa-upload"></i>
                      Upload Sales Orders For Resolution Report Raw File
                    </button>
                    <button type="button" class="btn btn-primary btn-sm-block mt-1 ml-xl-2 ml-lg-2 ml-md-2 ml-sm-2 text-start" 
                      @click="showValidatorModal = true">
                      <i class="fas fa-download"></i>
                      Generate Sales Orders For Resolution Report Validator by Principal
                    </button>
                    <button type="button" class="btn btn-primary btn-sm-block mt-1 ml-xl-2 ml-lg-2 ml-md-2 ml-sm-2 text-start"
                      @click="downloadTemplate">
                      <i class="fas fa-download"></i>
                      Download Sales Orders For Resolution Report Template
                    </button>
                  </div>

                  <!-- Center Side -->
                  <div class="col-lg-3 col-md-3 col-12">
                  </div>
                  <div class="col-lg-3 col-md-3 col-12">
                  </div>

                  <!-- Right Side -->
                  <div class="col-lg-3 col-md-3 col-12 text-right">
                    <button type="button" class="btn btn-primary btn-sm-block mt-1 ml-xl-2 ml-lg-2 ml-md-2 ml-sm-2"
                      @click="pendingSalesOrderCSReportModal = true">
                      <i class="fas fa-file-export"></i>
                      Generate Sales Orders For Resolution Report Report
                    </button>
                  </div>
                </div>
              </div>
              <div>
                <lottie-animation style="height: 500px" :loop="true"
                  :animationData="require('@/assets/lottie/report.json')" />
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <!-- upload modal -->
      <b-modal v-model="uploadModalShow" size="md" title="Sales Orders For Resolution Report" hide-footer no-close-on-backdrop>
        <form class="forms-sample">
          <div class="row">
            <div class="col">
              <div class="form-group">
                <label for="txtFirstName">Raw File</label>
                <input class="form-control" type="file" v-on:change="handleFileUpload($event)"
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" />
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col">
              <!-- <button type="button" class="btn btn-primary mr-2" @click="uploadFile"> -->
              <button type="button" class="btn btn-primary mr-2" @click="uploadFileV2">
                Upload
              </button>
              <button type="button" class="btn btn-light" @click="uploadModalShow = !uploadModalShow">
                Cancel
              </button>
            </div>
          </div>
        </form>
      </b-modal>
  
      <!-- generate report modal -->
      <b-modal v-model="pendingSalesOrderCSReportModal" size="md" title="Sales Orders For Resolution Report" hide-footer no-close-on-backdrop>
        <form class="forms-sample">
          <div class="row">
            <div class="col">
              <div class="form-group">
                <label for="chkReportType">Report Type</label>
                <div class="row">
                  <div class="col">
                    <div class="form-check">
                      <label class="form-check-label">
                        <input type="radio" class="form-check-input" value="principal" v-model="reportType"
                          :disabled="isGenerating" />
                        Principal Report
                        <i class="input-helper"></i></label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="form-group">
                <label for="txtReportDate">Report Date</label>
                <!-- <date-picker v-model="pendingSalesOrderReportFilter.dateRange" :clearable="false" format="MM/DD/YYYY" -->
                <date-picker v-model="pendingSalesOrderCSReportFilter.date" :clearable="false" format="MM/DD/YYYY"
                    title-format="MM/DD/YYYY" time-title-format="MM/DD/YYYY" input-class="form-control"
                    :input-attr="{ id: 'txtReportDate' }" :disabled="isGenerating" single></date-picker>
              </div>
              <div class="">
                <label for="txtReportTime">Time</label><br />
                <vue-timepicker v-model="pendingSalesOrderCSReportFilter.timePicked" format="h A" input-class="border rounded-3 w-100"
                  :input-attr="{ id: 'txtReportTime' }" :disabled="isGenerating" close-on-complete></vue-timepicker>
              </div>
            </div>
          </div>
          <div class="row" v-if="reportType == 'principal'">
            <div class="col">
              <div class="form-group">
                <label for="txtPrincipalCode">Principal Code</label>
                <multiselect id="txtPrincipalCode" v-model="value" placeholder="Search Principal Code" label="name"
                  track-by="code" :options="principalOptions" :multiple="true"></multiselect>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="form-check form-check-flat form-check-primary">
                <label class="form-check-label">
                  <!-- <input type="checkbox" class="form-check-input" v-model="stockOnHandReportFilter.isOfficial" -->
                  <input type="checkbox" class="form-check-input" v-model="pendingSalesOrderCSReportFilter.isOfficial"
                    :disabled="isGenerating" />
                  Is Official
                  <i class="input-helper"></i></label>
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col">
              <button type="button" class="btn btn-primary mr-2" @click="generatePendingSalesOrderCSReport"
                :disabled="isGenerating">
                <i class="fas fa-spinner fa-spin mr-1" v-if="isGenerating" />
                Generate
              </button>
              <button type="button" class="btn btn-light" @click="
                            pendingSalesOrderCSReportModal = !pendingSalesOrderCSReportModal;
                          reportType = 'principal';
                          " :disabled="isGenerating">
                Cancel
              </button>
            </div>
          </div>
        </form>
      </b-modal>

      <!-- validator report modal -->
      <b-modal v-model="showValidatorModal" size="md" title="Sales Orders For Resolution Report Validator" hide-footer no-close-on-backdrop>
        <form class="forms-sample">
          <div class="row">
            <div class="col">
              <div class="form-group">
                <label for="txtReportDateRange">Report Date</label>
                <date-picker v-model="pendingSalesOrderCSReportFilter.date" :clearable="false" format="MM/DD/YYYY" 
                  title-format="MM/DD/YYYY" time-title-format="MM/DD/YYYY" input-class="form-control"
                  :input-attr="{ id: 'txtReportDateRange' }" :disabled="isGenerating" single></date-picker>
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col">
              <button type="button" class="btn btn-primary mr-2" @click="generatePendingSalesOrderCSValidator"
                :disabled="isGenerating">
                <i class="fas fa-spinner fa-spin mr-1" v-if="isGenerating" />
                Generate
              </button>
              <button type="button" class="btn btn-light" @click="showValidatorModal = !showValidatorModal"
                :disabled="isGenerating">
                Cancel
              </button>
            </div>
          </div>
        </form>
      </b-modal>
  
    </div>
</template>

<script>
  import { mapState } from "vuex";
  import LottieAnimation from "lottie-web-vue";
  
  export default {
      components: {
          LottieAnimation,
      },
      data() {
          return {
              value: [],
              reportType: "principal",
              reportDateRange: [new Date(), new Date()],
              pendingSalesOrderCSReportPageItems: [],
              pendingSalesOrderCSReportModal: false,
              uploadModalShow: false,
              showValidatorModal: false,
              pageSize: 15,
              currentPage: 1,
              pageOfItems: [],
              isSearching: false,
              hasNoRecord: false,
              emailError: "",
              passwordError: "",
              isEdit: false,
              isGenerating: false,
              reportVersion: "2",
              file: null,
          };
      },
      computed: {
      ...mapState({
        principals: (state) => state.principalController.principals,
        pendingSalesOrderCSReports: (state) => state.reportController.pendingSalesOrderCSReports,
        pendingSalesOrderCSLast: (state) => state.reportController.pendingSalesOrderCSLast,
        pendingSalesOrderCSReportFilter: (state) => state.reportController.pendingSalesOrderCSReportFilter
      }),
      rows() {
        return this.pendingSalesOrderCSReports.length;
      },
      principalOptions() {
        return this.principals.map((mg) => ({
          ["name"]: mg.principalCode,
          ["code"]: mg.principalCode + "-001",
        }));
      },
    },
    validations: {
      stockOnHandReportFilter: {
        // dateRange: {
        //   required,
        // },
      },
      pendingSalesOrderCSReportFilter: {
          
      }
    },
    watch: {
      reportType: {
        handler() {
          this.value = [];
        },
        deep: true,
      },
    },
    methods: {
      paginationChanged: function (page) {
        if (page == null) {
          page = 1;
        }
  
      //   this.binCardReportPageItems = this.binCardReports.slice(
      //     (page - 1) * this.pageSize,
      //     page * this.pageSize
      //   );
        this.pendingSalesOrderCSReportPageItems = this.pendingSalesOrderCSReports.slice(
          (page - 1) * this.pageSize,
          page * this.pageSize
        );
      },
      handleFileUpload(event) {
        this.file = event.target.files[0];
      },
      generateReport() {
        this.$toast.open({
          message: "This feature is not yet implemented.",
          type: "info",
        });
      },
  
      async generatePendingSalesOrderCSReport() {
        this.$v.$touch();
  
        if (!this.$v.pendingSalesOrderCSReportFilter.$invalid) {
          this.isGenerating = true;
          this.pendingSalesOrderCSReportFilter.principalCode = this.value
            .map((mg) => mg.name)
            .join("~");
  
          var result = false;
  
          // if (this.reportType == "fieldforce") {
          //   result = await this.$store
          //     .dispatch("reportController/GetInventoryLevelFieldforceReports")
          //     .catch(async (error) => {
          //       this.isGenerating = false;
          //       await this.$store.dispatch("showOverlay", false);
          //       this.$toast.open({
          //         message: error.data.Message,
          //         type: "error",
          //       });
          //     });
          // } else if (this.reportType == "district") {
          //   result = await this.$store
          //     .dispatch("reportController/GetInventoryLevelDMReports")
          //     .catch(async (error) => {
          //       this.isGenerating = false;
          //       await this.$store.dispatch("showOverlay", false);
          //       this.$toast.open({
          //         message: error.data.Message,
          //         type: "error",
          //       });
          //     });
          // } else if (this.reportType == "nationalsales") {
          //   result = await this.$store
          //     .dispatch("reportController/GetInventoryLevelNSMReports")
          //     .catch(async (error) => {
          //       this.isGenerating = false;
          //       await this.$store.dispatch("showOverlay", false);
          //       this.$toast.open({
          //         message: error.data.Message,
          //         type: "error",
          //       });
          //     });
          // } else if (this.reportType == "regionalsales") {
          //   result = await this.$store
          //     .dispatch("reportController/GetInventoryLevelRSMReports")
          //     .catch(async (error) => {
          //       this.isGenerating = false;
          //       await this.$store.dispatch("showOverlay", false);
          //       this.$toast.open({
          //         message: error.data.Message,
          //         type: "error",
          //       });
          //     });
          // } else {
            result = await this.$store
              .dispatch("reportController/GetPendingSalesOrderCSReports")
              .catch(async (error) => {
                this.isGenerating = false;
                await this.$store.dispatch("showOverlay", false);
                this.$toast.open({
                  message: error.data.Message,
                  type: "error",
                });
              });
          // }
  
          if (result) {
            this.pendingSalesOrderCSReportModal = false;
            this.reportType = "principal";
            this.isGenerating = false;
            this.value = [];
  
            this.$toast.open({
              message: "Report has been saved.",
              type: "success",
            });
          }
        }
      },
  
      async uploadFileV2() {
          var result = false;
          await this.$store.dispatch("showOverlay", true);
  
          result = await this.$store
          .dispatch("reportController/UploadPendingSalesOrderCSReports", this.file)
          .catch(async (error) => {
              await this.$store.dispatch("showOverlay", false);
              this.$toast.open({
              message: error.data.Message,
              type: "error",
              });
          });
  
        if (result) {
          await this.searchFilter();
          await this.$store.dispatch("showOverlay", false);
          this.uploadModalShow = false;
          this.$toast.open({
            message: "Report has been uploaded.",
            type: "success",
          });
        }
      },
      async generatePendingSalesOrderCSValidator() {
        this.$v.$touch();

        if (!this.$v.pendingSalesOrderCSReportFilter.$invalid) {
          this.isGenerating = true;

          var result = await this.$store
            .dispatch("reportController/GetPendingSalesOrderCSReportsValidation")
            .catch(async (error) => {
              this.isGenerating = false;
              await this.$store.dispatch("showOverlay", false);
              this.$toast.open({
                message: error.data.Message,
                type: "error",
              });
            });

          if (result) {
            this.showValidatorModal = false;
            this.isGenerating = false;
            this.value = [];

            this.$toast.open({
              message: "Report has been saved.",
              type: "success",
            });
          }
        }
      },
      downloadTemplate: async function () {
        this.isGenerating = true;

        var result = false;
        result = await this.$store
          .dispatch("reportController/GetPendingSalesOrderCSReports_Template")
          .catch(async (error) => {
            this.isGenerating = false;
            await this.$store.dispatch("showOverlay", false);
            this.$toast.open({
              message: error.data.Message,
              type: "error",
            });
          });

        if (result) {
          this.isGenerating = false;
          this.value = [];

          // this.$toast.open({
          //   message: "Report Templated has been downloaded.",
          //   type: "success",
          // });
        }
      },
      searchFilter: async function () {
        this.currentPage = 1;
        this.pageOfItems = [];
        this.isSearching = true;
        this.hasNoRecord = false;
        // var result = await this.$store
        //   .dispatch("reportController/GetBinCardReports")
        //   .catch((error) => {
        //     this.hasNoRecord = true;
        //     this.isSearching = false;
        //   });
  
        // if (result) {
        if (true) {
          this.paginationChanged();
          this.isSearching = false;
  
          // if (this.binCardReports.length == 0) {
          //   this.hasNoRecord = true;
          // }
          if (this.pendingSalesOrderCSReports.length == 0) {
              this.hasNoRecord = true;
          }
        }
      },
    },
    async mounted() {
      await this.searchFilter();
      await this.$store
        .dispatch("reportController/GetPendingSalesOrderCS_Date")
        .catch((error) => {
          this.isSearching = false;
        });
      this.pendingSalesOrderCSReportFilter.date = this.pendingSalesOrderCSLast != null && this.pendingSalesOrderCSLast.dateUploaded != null ?
            new Date(this.pendingSalesOrderCSLast.dateUploaded) :
            new Date();
    },
  };
  </script>
  
  <style scoped>
  .mx-datepicker-range {
    width: 100%;
  }
  </style>